import { useState } from "react";
import { TbCopy } from "react-icons/tb";
import { TbCopyCheckFilled } from "react-icons/tb";

function CopyComponent({ toCopy }) {

  const [isCopied, setIsCopied] = useState(false)

  async function copyToClipboard(textToCopy) {
    // Navigator clipboard api needs a secure context (https)
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(textToCopy);
    } else {
      // Use the 'out of viewport hidden text area' trick
      const textArea = document.createElement("textarea");
      textArea.value = textToCopy;

      // Move textarea out of the viewport so it's not visible
      textArea.style.position = "absolute";
      textArea.style.left = "-999999px";

      document.body.prepend(textArea);
      textArea.select();

      try {
        document.execCommand('copy');
      } catch (error) {
        console.error(error);
      } finally {
        textArea.remove();
      }
    }
  }

  const handleDetailCopy = (detail) => {
    try {
      copyToClipboard(detail)
        .then(() => [
          setIsCopied(true)
        ])
    } catch (error) {
      // console.log(error);
    }
  }

  if (isCopied)
    return (
      <TbCopyCheckFilled onClick={() => { handleDetailCopy(toCopy) }} className='w-3.5 md:w-8 h-3.5 md:h-4 cursor-pointer text-headPrimary hover:text-headPrimary' />
    )
  else
    return (
      <TbCopy onClick={() => { handleDetailCopy(toCopy) }} className='w-3.5 md:w-8 h-3.5 md:h-4 cursor-pointer text-gray-600 hover:text-headPrimary' />
    )
}

export default CopyComponent